import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Tabs from 'srcReact/components/common2/Tabs'
import Pending from './components/Pending'
import Accepted from './components/Accepted'
import Header from './components/Header'
import { workplaceSettingsActions } from 'srcReact/WorkplaceSettingsPage'
import InvitationsFromEnity from 'srcReact/WorkplaceSettingsPage/components/ManageInvites/components/InvitationsFromEnity'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'

const ManageInvites = ({ selectedWorkplace }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const [initialActive, setInitialActive] = useState(0)
  const [status, setStatus] = useState('pending')
  const [searchText, setSearchText] = useState('')
  const [orderby, setOrderby] = useState('firstSent')
  const [orderByOptions, setOrderByOptions] = useState([
    { value: 'firstSent', label: t('orderBy.firstSent') },
    { value: 'lastSent', label: t('orderBy.lastSent') }
  ])
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })

  const {
    workplaceSettings: {
      manage_invites: { loading, stats }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (selectedWorkplace?.id > 0) {
      dispatch(
        workplaceSettingsActions.getWorkplaceManageInvites(
          selectedWorkplace?.id,
          status,
          searchText,
          orderby,
          pagination.isPagination,
          pagination.nextOffset
        )
      )
    }
  }, [selectedWorkplace, status, searchText, orderby, pagination])

  const handleActiveTab = (tabActive, tabName) => {
    setPagination({
      nextOffset: 0,
      isPagination: false
    })
    if (tabActive === 0 || tabActive === 2) {
      setOrderby('firstSent')
    } else if (tabActive === 1) {
      setOrderby('lastJoined')
    }
    setInitialActive(tabActive)
    setStatus(tabName)
  }

  const lastRef = useInfinitScroll(loading, stats && stats.remaining, stats && stats.next_offset, setPagination, [
    loading
  ])

  return (
    <div className={styles.manageInvitesWrapper}>
      <Tabs initialActive={initialActive} className={styles.tabs} type='boxed' aligned='centered'>
        <div label={t('global.pending')} onClick={() => handleActiveTab(0, 'pending')}>
          <Header
            setOrderby={setOrderby}
            searchText={searchText}
            setSearchText={setSearchText}
            orderByOptions={orderByOptions}
          />
          <Pending setPagination={setPagination} selectedWorkplace={selectedWorkplace} />
        </div>
        <div label={t('global.accepted')} onClick={() => handleActiveTab(1, 'joined')}>
          <Header
            setOrderby={setOrderby}
            searchText={searchText}
            setSearchText={setSearchText}
            orderByOptions={[
              { value: 'lastJoined', label: t('orderBy.lastJoined') },
              { value: 'firstname', label: t('orderBy.name') }
            ]}
          />
          <Accepted setPagination={setPagination} selectedWorkplace={selectedWorkplace} />
        </div>
        <div label={t('components.invite_list.requested')} onClick={() => handleActiveTab(2, 'invitation_from_entity')}>
          <Header
            setOrderby={setOrderby}
            searchText={searchText}
            setSearchText={setSearchText}
            orderByOptions={orderByOptions}
            setPagination={setPagination}
          />
          <InvitationsFromEnity workplaceId={selectedWorkplace?.id} lastRef={lastRef} />
        </div>
      </Tabs>
    </div>
  )
}

export default ManageInvites
